import { FC } from 'react';
import { DeleteDialog } from '@bom-nextgen-keycloak/web/shared/ui';

type PolicyDeleteDialogProps = {
  loading?: boolean;
  name?: string | null;
  onClose: () => void;
  onSubmit: () => void;
  open?: boolean;
};

const PolicyDeleteDialog: FC<PolicyDeleteDialogProps> = ({
  loading = false,
  name = 'unknown',
  onClose,
  onSubmit,
  open = false,
}) => {
  return (
    <DeleteDialog
      description={`
    You are about to permanently delete <b>${name}</b> and its relationships. <b>This operation cannot be undone.</b>`}
      loading={loading}
      open={open}
      onClose={onClose}
      onDelete={onSubmit}
      title="Delete policy?"
    />
  );
};

export { PolicyDeleteDialog };
